import css from 'styled-jsx/css'

import { colors, common, sizes } from '../../../theme'


export default css`
.container {
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  padding-top: 1rem;
}

.container :global(.techno-content) {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.container :global(.technology) {
  ${common.t2}
  color: ${colors.pureWhite};
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  .container :global(.techno-content) {
    flex-direction: column;
  }

  .container :global(.technology) {
    ${common.regular16}
  }
}
`
